import { toast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { getMergeConfig } from "@/config/mergeConfigRegistry";
import { generateSelectFieldsFromConfig } from "@/utils/mergeConfigUtils";

// Type definition for Job (you may want to move this to a types file)
export interface Job {
  id: string;
  title: string;
  description?: string;
  skills?: string[];
  hard_skills?: string[];
  soft_skills?: string[];
  status?: string;
  company_id?: string;
  location?: string;
  salary_min?: number;
  salary_max?: number;
  created_at?: string;
  updated_at?: string;
  ai_analysis?: any;
  ai_summary?: string;
}

// Function to fetch specific jobs from database by IDs
export const fetchJobsByIds = async (jobIds: string[]): Promise<Job[]> => {
  try {
    // Get the appropriate select fields from the merge configuration
    const mergeConfig = getMergeConfig("jobs");
    const selectFields = mergeConfig ? generateSelectFieldsFromConfig(mergeConfig) : "*";
    
    //console.log(`🔍 Fetching jobs with fields: ${selectFields}`);
    
    const { data, error } = await supabase
      .from('jobs')
      .select(selectFields)
      .in('id', jobIds);
    
    if (error) {
      console.error("Error fetching jobs by IDs:", error);
      throw error;
    }

    if (data) {
      const transformedData: Job[] = data as unknown as Job[];
      
      return transformedData;
    }
    
    return [];
  } catch (error) {
    console.error("Error fetching jobs by IDs:", error);
    toast({
      title: "Failed to load fresh job data",
      description: "Using cached data instead.",
      variant: "destructive",
    });
    return [];
  }
};